export const VISIT = { value: "VISIT", text: "Visit" };
export const DAYS = { value: "DAYS", text: "Days" };
